const faq = {

faq: {
  meta: {
    title: "Häufig gestellte Fragen",
    subtitle:
      "Finde schnelle Antworten zu Konten, Beiträgen, Standort, Datenschutz, Chat, Sicherheit, Werbung und Problemlösungen.",
    back: "Zurück",
    overviewTitle: "Hilfe & Support",
    searchPlaceholder: "FAQ durchsuchen",
  },

  sidebar: {
    feedsPosting: "Feeds & Beiträge",
    locationPrivacy: "Standort & Datenschutz",
    chatEncryption: "Chat & Verschlüsselung",
    accountSecurity: "Konto & Sicherheit",
    followingLikes: "Likes, Folgen & Benachrichtigungen",
    safetyReporting: "Sicherheit, Meldungen & Moderation",
    adsBilling: "Werbung & Abrechnung",
    troubleshooting: "Problembehebung",
  },

  overview: {
    whatIsGallery: "Was ist die Galerie?",
    myPreferencesFeed: "Was ist Mein Feed?",
    myLikesFeed: "Was ist Meine Likes?",
    musicPostFeed: "Was ist der Musik-Feed?",
    locationPostFeed: "Was ist der Standort-Feed?",
    howManyMedia: "Wie viele Fotos/Videos kann ich in einem Beitrag hinzufügen?",
    postOrder: "Wie werden Beiträge in der Galerie sortiert?",
    changeLocationFeed: "Kann ich den Standort meines Galerie-Feeds ändern?",
    presentationMode: "Was ist der Präsentationsmodus?",
    hiddenHashtags: "Was sind versteckte Hashtags?",
    hiddenHashtagsVisibility: "Werden versteckte Hashtags in Beiträgen angezeigt?",
    whyNoHiddenHashtag: "Warum finde ich keine Beiträge zu einem Hashtag?",
    locationChangePost: "Kann ich den Standort eines Beitrags nach der Veröffentlichung ändern?",
    musicOnPosts: "Kann ich die Musik eines Videos nach der Veröffentlichung ändern?",
    addMusicPost: "Wie kann ich Musik zu einem Beitrag hinzufügen?",
    filters: "Kann ich Filter auf Fotos und Videos anwenden?",
    editAfterPost: "Kann ich einen Beitrag nach der Veröffentlichung bearbeiten?",
    uploadFailed: "Mein Upload schlägt fehl oder bleibt hängen. Was kann ich tun?",
    videoFormat: "Welches Videoformat funktioniert am besten?",
    whyPostNotVisible: "Warum sehe ich meinen Beitrag nicht in der Galerie?",
    seeOwnPosts: "Wo finde ich meine eigenen Beiträge?",
    removeMediaBeforePost: "Kann ich Medien vor der Veröffentlichung wieder entfernen?",

    locationNeeded: "Warum benötigt Elnydo meinen Standort?",
    changeLocationVsPosting: "Ändert das Wechseln meines Feed-Standorts auch den Standort neuer Beiträge?",
    whatLocationStored: "Welche Standortdaten werden mit meinem Beitrag gespeichert?",
    turnOffLocation: "Kann ich Elnydo ohne aktivierten Standort nutzen?",
    vpnLocation: "Ändert ein VPN den Standort meines Beitrags?",
    whoSeesLocation: "Wer kann den Standort meines Beitrags sehen?",
    hideLikeActivity: "Kann ich meine Likes oder Aktivitäten verbergen?",
    profilePrivacy: "Kann ich mein Profil privat machen?",
    blockedPrivacy: "Verbirgt das Blockieren einer Person meine Inhalte vor ihr?",
    dataMinimization: "Verkauft Elnydo meine Daten oder verfolgt mich für Werbung?",
    reportingPrivacy: "Sind Meldungen anonym?",
    deleteLocationData: "Verschwindet die Standortkennzeichnung, wenn ich einen Beitrag lösche?",

    startChat: "Wie starte ich eine Unterhaltung?",
    whoCanMessageMe: "Wer kann mir Nachrichten senden?",
    isChatE2ee: "Ist der Chat Ende-zu-Ende verschlüsselt (E2EE)?",
    chatMetadata: "Welche Metadaten existieren trotz E2EE?",
    canElnydoReadChat: "Kann Elnydo meine Chatnachrichten lesen?",
    sendMediaChat: "Kann ich Fotos und Videos im Chat versenden?",
    deleteChatMessage: "Kann ich eine Chatnachricht löschen?",
    lostDeviceChat: "Was passiert, wenn ich mein Gerät verliere?",
    messageNotDelivered: "Warum werden meine Nachrichten nicht zugestellt?",
    blockedChat: "Kann ich mit einem blockierten Nutzer chatten?",
    groupChats: "Unterstützt Elnydo Gruppenchats?",
    screenshots: "Verhindert Elnydo Screenshots im Chat?",
    chatSearch: "Kann ich innerhalb von Chats suchen?",
    chatAttachmentsFail: "Warum schlägt das Senden von Medien im Chat fehl?",

    forgotPassword: "Ich habe mein Passwort vergessen. Was soll ich tun?",
    changeEmail: "Kann ich meine E-Mail-Adresse ändern?",
    changePassword: "Wie ändere ich mein Passwort?",
    reauthWhy: "Warum fordert Elnydo eine erneute Anmeldung an?",
    logoutEverywhere: "Kann ich mich auf allen Geräten gleichzeitig abmelden?",
    suspiciousLogin: "Ich sehe verdächtige Aktivitäten. Was soll ich tun?",
    twoFactor: "Unterstützt Elnydo die Zwei-Faktor-Authentifizierung (2FA)?",
    accountDeletion: "Wie lösche ich mein Konto?",
    anonymizedWhat: "Was bedeutet „anonymisiert“, wenn ich mein Konto lösche?",
    blockedUsersList: "Wo finde ich die Liste blockierter Nutzer?",
    usernameChange: "Kann ich meinen Profilnamen ändern?",
    deviceChange: "Was passiert, wenn ich das Smartphone wechsle?",

    likeUnlike: "Wie vergebe oder entferne ich ein Like?",
    seeLikedPosts: "Wo sehe ich Beiträge, die ich gelikt habe?",
    followUnfollow: "Wie folge ich jemandem oder entfolge ihm?",
    followersFollowing: "Was ist der Unterschied zwischen Followern und Ich folge?",
    followNotification: "Werden Nutzer benachrichtigt, wenn ich ihnen folge?",
    likeNotification: "Werden Nutzer benachrichtigt, wenn ich ihren Beitrag like?",
    notificationSettings: "Kann ich Benachrichtigungen deaktivieren?",
    notificationsNotWorking: "Warum erhalte ich keine Benachrichtigungen?",
    muteUser: "Kann ich jemanden stummschalten, ohne ihn zu blockieren?",
    visibilityFollowing: "Verändert das Folgen, was ich in der Galerie sehe?",

    whenBlock: "Wann sollte ich einen Nutzer blockieren?",
    whenReport: "Wann sollte ich einen Beitrag oder ein Konto melden?",
    whatHappensReport: "Was passiert nach einer Meldung?",
    appeal: "Kann ich gegen eine Moderationsentscheidung Einspruch einlegen?",
    falseReport: "Was passiert, wenn mich jemand zu Unrecht meldet?",
    scams: "Wie kann ich Betrug auf Elnydo vermeiden?",
    dangerEmergency: "Was soll ich tun, wenn jemand in unmittelbarer Gefahr ist?",
    copyright: "Was gilt für Urheberrechte und das erneute Veröffentlichen von Inhalten?",
    hateSpeech: "Erlaubt Elnydo Hassrede oder Belästigung?",
    privacyViolations: "Was kann ich tun, wenn jemand meine privaten Informationen veröffentlicht?",

    adsRequired: "Benötige ich Werbung, um Elnydo zu nutzen?",
    createAd: "Wie erstelle ich eine Werbekampagne?",
    adTargeting: "Wie funktioniert das Anzeigen-Targeting?",
    adReviewTime: "Wie lange dauert die Prüfung einer Anzeige?",
    adRejected: "Warum wurde meine Anzeige abgelehnt?",
    billingWhenCharged: "Wann werden Werbekosten berechnet?",
    adSpendNotDelivering: "Warum wird mein Werbebudget nicht ausgegeben oder meine Anzeige nicht ausgeliefert?",
    adCreativeBest: "Was macht eine gute Werbeanzeige aus?",
    refunds: "Bietet ihr Rückerstattungen für Werbung an?",
    invoices: "Wo finde ich meine Rechnungen?",

    appCrashes: "Die App stürzt ab oder friert ein. Was kann ich tun?",
    cantLogin: "Ich kann mich nicht anmelden. Woran kann das liegen?",
    slowFeed: "Die Galerie ist langsam. Wie kann ich sie beschleunigen?",
    noSound: "Mein Video hat keinen Ton. Warum?",
    cameraPermission: "Die Berechtigung für Kamera oder Fotos fehlt. Wie behebe ich das?",
    locationPermission: "Die Standortberechtigung fehlt. Wie behebe ich das?",
    notificationsDisabled: "Benachrichtigungen sind in der App aktiviert, ich erhalte aber trotzdem keine.",
    blockedContent: "Warum sehe ich weniger Beiträge als mein Freund in derselben Stadt?",
    profileNotUpdating: "Änderungen an meinem Profil werden nicht angezeigt.",
    contactSupportWhen: "Wann sollte ich den Support kontaktieren?",
  },



sections: {

//////////////////////////////////////
////////Feeds & Beiträge//////////////
//////////////////////////////////////

  "what-is-gallery": {
    title: "Was ist die Galerie?",
    body: [
      {
        type: "paragraph",
        text: "Die Galerie ist der Haupt-Feed von Elnydo, in dem du Beiträge, Fotos und Videos von deinem aktuellen oder einem ausgewählten Standort entdecken kannst.",
      },
    ],
  },

  "my-preferences-feed": {
    title: "Was ist Mein Feed?",
    body: [
      {
        type: "paragraph",
        text: "Mein Feed zeigt Beiträge von Profilen, denen du folgst. So kannst du schnell neue Inhalte von Personen und Profilen sehen, die dich interessieren.",
      },
    ],
  },

  "my-likes-feed": {
    title: "Was ist Meine Likes?",
    body: [
      {
        type: "paragraph",
        text: "Meine Likes zeigt alle Beiträge, die du mit „Gefällt mir“ markiert hast. Dadurch kannst du Inhalte leichter wiederfinden, ohne sie erneut suchen zu müssen.",
      },
    ],
  },

  "add-music-post": {
    title: "Wie kann ich Musik zu einem Beitrag hinzufügen?",
    body: [
      {
        type: "paragraph",
        text: "Musik kann ausschließlich zu Videobeiträgen hinzugefügt werden. Wähle während des Uploads „Musik hinzufügen“, wenn du deinem Video einen Musiktitel zuordnen möchtest. Andere Nutzer können anschließend den Musiktitel öffnen und weitere Beiträge entdecken, die denselben Titel verwenden.",
      },
      {
        type: "note",
        text: "Falls dein Video bereits vor dem Hochladen Musik enthält, bist du selbst dafür verantwortlich, dass du über die erforderlichen Rechte, Genehmigungen oder Lizenzen zur Nutzung dieser Musik verfügst.",
      },
    ],
  },

  "music-post-feed": {
    title: "Was ist der Musik-Feed?",
    body: [
      {
        type: "paragraph",
        text: "Der Musik-Feed zeigt Beiträge, die denselben Musiktitel verwenden. Wenn du einen Musik-Feed öffnest (durch Anklicken eines Musiktitels), kannst du weitere Beiträge entdecken, die mit diesem Titel verknüpft sind.",
      },
    ],
  },

  "location-post-feed": {
    title: "Was ist der Standort-Feed?",
    body: [
      {
        type: "paragraph",
        text: "Der Standort-Feed zeigt Beiträge vom gleichen Standort. So kannst du weitere Inhalte entdecken, die mit einer bestimmten Stadt oder einem bestimmten Land verbunden sind.",
      },
    ],
  },

  "how-many-media": {
    title: "Wie viele Fotos und Videos kann ich in einem Beitrag hinzufügen?",
    body: [
      {
        type: "paragraph",
        text: "Ein einzelner Beitrag kann bis zu 8 Medien enthalten, davon maximal 1 Video.",
      },
    ],
  },

  "post-order": {
    title: "Wie werden Beiträge in der Galerie sortiert?",
    body: [
      {
        type: "paragraph",
        text: "Innerhalb jedes Standortbereichs werden Beiträge in der Regel nach Veröffentlichungszeit sortiert – die neuesten Beiträge zuerst.",
      },
    ],
  },

  "change-location-feed": {
    title: "Kann ich den Standort meines Galerie-Feeds ändern?",
    body: [
      {
        type: "paragraph",
        text: "Ja. Mit „Standort ändern“ kannst du Beiträge aus einer anderen Stadt oder einem anderen Land ansehen. Dadurch ändert sich nur der Inhalt deines Feeds – der Standort deiner eigenen Beiträge bleibt unverändert.",
      },
    ],
  },

  "hidden-hashtags": {
    title: "Was sind versteckte Hashtags?",
    body: [
      {
        type: "paragraph",
        text: "Versteckte Hashtags dienen dazu, Beiträge zu kategorisieren, ohne dass die Hashtags öffentlich angezeigt werden. Sie können beim Erstellen oder Bearbeiten eines Beitrags hinzugefügt und später für die Suche nach ähnlichen Inhalten verwendet werden.",
      },
    ],
  },

  "hidden-hashtags-visibility": {
    title: "Werden versteckte Hashtags in Beiträgen angezeigt?",
    body: [
      {
        type: "paragraph",
        text: "Nein. Versteckte Hashtags werden ausschließlich für die Kategorisierung und Suche verwendet und sind in Beiträgen nicht öffentlich sichtbar.",
      },
    ],
  },

  "why-no-hidden-hashtag": {
    title: "Warum finde ich keine Beiträge zu einem Hashtag?",
    body: [
      {
        type: "paragraph",
        text: "Möglicherweise existieren derzeit keine Beiträge mit diesem Hashtag, der Hashtag wurde falsch geschrieben, entsprechende Beiträge wurden entfernt oder sind aufgrund ihrer Sichtbarkeitseinstellungen nicht verfügbar.",
      },
    ],
  },

  "presentation-mode": {
    title: "Was ist der Präsentationsmodus?",
    body: [
      {
        type: "paragraph",
        text: "Der Präsentationsmodus ist die Vollbildansicht eines Beitrags. Dabei wird jeweils nur ein Medium angezeigt. Du kannst mit den Pfeiltasten oder den Pfeilschaltflächen zwischen den Medien wechseln und die Ansicht über die Schließen-Schaltfläche oder die Escape-Taste beenden.",
      },
    ],
  },

  "music-on-posts": {
    title: "Kann ich die Musik eines Videos nach der Veröffentlichung ändern?",
    body: [
      {
        type: "paragraph",
        text: "Nein. Nachdem ein Beitrag veröffentlicht wurde, kann die Musik eines Videos nicht mehr geändert oder hinzugefügt werden.",
      },
    ],
  },

  "filters": {
    title: "Kann ich Filter auf Fotos oder Videos anwenden?",
    body: [
      {
        type: "paragraph",
        text: "Ja, sofern Filter in deinem Upload-Bereich verfügbar sind. Filter können während der Vorschau vor der Veröffentlichung angewendet werden.",
      },
    ],
  },

  "edit-after-post": {
    title: "Kann ich einen Beitrag nach der Veröffentlichung bearbeiten?",
    body: [
      {
        type: "paragraph",
        text: "Nach der Veröffentlichung kannst du bestimmte Informationen, wie versteckte Hashtags, bearbeiten oder einzelne Medien entfernen. Bereits hochgeladene Mediendateien können jedoch nicht ersetzt und keine neuen Medien hinzugefügt werden.",
      },
    ],
  },

  "location-change-post": {
    title: "Kann ich den Standort eines Beitrags nach der Veröffentlichung ändern?",
    body: [
      {
        type: "paragraph",
        text: "Nein. Der Standort eines Beitrags kann nach der Veröffentlichung nicht mehr geändert werden. Jeder Beitrag verwendet dauerhaft den Standort, der beim Erstellen zugewiesen wurde.",
      },
    ],
  },

  "upload-failed": {
    title: "Mein Upload schlägt fehl oder bleibt hängen. Was kann ich tun?",
    body: [
      {
        type: "bullets",
        items: [
          "Wechsle gegebenenfalls das Netzwerk, zum Beispiel von WLAN zu mobilen Daten oder umgekehrt.",
          "Reduziere die Dateigröße vor dem Hochladen.",
          "Stelle sicher, dass die App über alle erforderlichen Berechtigungen verfügt.",
          "Versuche den Upload erneut, nachdem du deine Internetverbindung überprüft hast.",
          "Sehr große oder lange Videos können häufiger zu Upload-Problemen führen.",
        ],
      },
    ],
  },

  "video-format": {
    title: "Welches Videoformat funktioniert am besten?",
    body: [
      {
        type: "paragraph",
        text: "Für eine zuverlässige Verarbeitung empfehlen wir gängige Formate wie MP4 mit H.264-Codec. Dateien mit extrem hoher Bitrate oder ungewöhnlichen Codecs können Probleme beim Hochladen oder Abspielen verursachen.",
      },
    ],
  },

  "why-post-not-visible": {
    title: "Warum sehe ich meinen Beitrag nicht in der Galerie?",
    body: [
      {
        type: "bullets",
        items: [
          "Überprüfe die Sichtbarkeitseinstellungen deines Beitrags.",
          "Aktualisiere den Feed.",
          "Stelle sicher, dass der Upload vollständig abgeschlossen wurde.",
          "Prüfe, ob du den richtigen Standortbereich ausgewählt hast.",
        ],
      },
    ],
  },

  "see-own-posts": {
    title: "Wo finde ich meine eigenen Beiträge?",
    body: [
      {
        type: "paragraph",
        text: "Deine Beiträge werden in deinem Profil angezeigt und können – abhängig vom zugewiesenen Standort und den Sichtbarkeitseinstellungen – auch in der Galerie erscheinen.",
      },
    ],
  },

  "remove-media-before-post": {
    title: "Kann ich Medien vor der Veröffentlichung wieder entfernen?",
    body: [
      {
        type: "paragraph",
        text: "Ja. Während der Vorschau kannst du einzelne Medien entfernen oder die gesamte Auswahl zurücksetzen, bevor du den Beitrag veröffentlichst.",
      },
    ],
  },

//////////////////////////////////
////Standort & Datenschutz////////
//////////////////////////////////

"location-needed": {
  title: "Warum benötigt Elnydo meinen Standort?",
  body: [
    {
      type: "paragraph",
      text: "Der Standort wird verwendet, um Beiträge einer Stadt oder einem Land zuzuordnen und standortbezogene Beiträge in der Galerie anzuzeigen. Dadurch können dir relevante Inhalte aus deiner Umgebung angezeigt werden.",
    },
  ],
},

"change-location-vs-posting": {
  title: "Ändert das Wechseln meines Feed-Standorts auch den Standort neuer Beiträge?",
  body: [
    {
      type: "paragraph",
      text: "Nein. „Standort ändern“ wirkt sich nur auf die angezeigten Inhalte aus. Beim Veröffentlichen eines Beitrags wird der aktuelle Standort deines Geräts zum Zeitpunkt des Uploads verwendet.",
    },
  ],
},

"what-location-stored": {
  title: "Welche Standortdaten werden mit meinem Beitrag gespeichert?",
  body: [
    {
      type: "paragraph",
      text: "Beiträge werden mit einer abgeleiteten Stadt- und Länderkennzeichnung gespeichert.",
    },
  ],
},

"turn-off-location": {
  title: "Kann ich Elnydo ohne aktivierten Standort nutzen?",
  body: [
    {
      type: "paragraph",
      text: "Einige Funktionen können eingeschränkt sein. Du kannst Inhalte weiterhin ansehen, jedoch funktionieren das Veröffentlichen von Beiträgen und standortbasierte Entdeckungsfunktionen ohne Standortzugriff möglicherweise nicht korrekt.",
    },
  ],
},

"vpn-location": {
  title: "Ändert ein VPN den Standort meines Beitrags?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Elnydo verwendet beim Erstellen eines Beitrags den Standort deines Geräts. Ein VPN kann zwar deine Netzwerkverbindung beeinflussen, bestimmt jedoch nicht den Standort eines Beitrags.",
    },
  ],
},

"who-sees-location": {
  title: "Wer kann den Standort meines Beitrags sehen?",
  body: [
    {
      type: "paragraph",
      text: "Andere Nutzer können in der Regel die Stadt- oder Länderkennzeichnung deines Beitrags sehen. Genaue GPS-Koordinaten werden nicht angezeigt.",
    },
  ],
},

"post-wo-location": {
  title: "Kann ich einen Beitrag ohne Standort veröffentlichen?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Für jeden Beitrag ist ein Standort erforderlich, damit er dem richtigen Standort-Feed zugeordnet und über die Entdeckungsfunktionen gefunden werden kann.",
    },
  ],
},

"profile-privacy": {
  title: "Kann ich mein Profil privat machen?",
  body: [
    {
      type: "paragraph",
      text: "Elnydo bietet derzeit keine privaten Profile an. Du kannst dein Konto deaktivieren, eigene Beiträge ausblenden oder einzelne Nutzer blockieren. Öffentliche Beiträge bleiben für andere Nutzer sichtbar, solange sie nicht ausgeblendet oder entfernt werden.",
    },
  ],
},

"blocked-privacy": {
  title: "Verbirgt das Blockieren einer Person meine Inhalte vor ihr?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Blockierte Nutzer können dir keine Nachrichten senden, dir nicht folgen und – soweit die Blockierung greift – weder dein Profil noch deine Inhalte ansehen.",
    },
  ],
},

"data-minimization": {
  title: "Verkauft Elnydo meine Daten oder verfolgt mich für Werbung?",
  body: [
    {
      type: "paragraph",
      text: "Grundsätzlich nein. Elnydo wurde nach dem Prinzip der Datenminimierung entwickelt. Weitere Informationen findest du in unserer Datenschutzrichtlinie und den Datenschutzinformationen.",
    },
  ],
},

"reporting-privacy": {
  title: "Sind Meldungen anonym?",
  body: [
    {
      type: "paragraph",
      text: "Meldungen werden intern geprüft. Gemeldete Nutzer erhalten in der Regel keine Informationen darüber, wer die Meldung eingereicht hat.",
    },
  ],
},

"delete-location-data": {
  title: "Verschwindet die Standortkennzeichnung, wenn ich einen Beitrag lösche?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Wenn ein Beitrag gelöscht wird, wird auch die dazugehörige Standortkennzeichnung zusammen mit dem Beitrag aus der öffentlichen Ansicht entfernt.",
    },
  ],
},


////////////////////////////////////////
///////////Chat & Verschlüsselung///////
////////////////////////////////////////

"start-chat": {
  title: "Wie starte ich eine Unterhaltung?",
  body: [
    {
      type: "paragraph",
      text: "Du kannst eine Unterhaltung über das Profil eines Nutzers oder direkt über einen seiner Beiträge starten.",
    },
    {
      type: "steps",
      items: [
        "Öffne das Profil oder den Beitrag des Nutzers.",
        "Wähle die Schaltfläche „Chat“ aus.",
        "Gib deine Nachricht ein.",
        "Sende die Nachricht, um die Unterhaltung zu beginnen.",
      ],
    },
  ],
},

"who-can-message-me": {
  title: "Wer kann mir Nachrichten senden?",
  body: [
    {
      type: "paragraph",
      text: "Jeder registrierte Elnydo-Nutzer kann über die Chat-Schaltfläche in einem Profil oder Beitrag eine Unterhaltung mit einem anderen Nutzer beginnen, sofern die Nachrichtenfunktion nicht durch eine Blockierung eingeschränkt ist.",
    },
    {
      type: "bullets",
      items: [
        "Nutzer, denen du folgst, können dir Nachrichten senden.",
        "Nutzer, die dir folgen, können dir Nachrichten senden.",
        "Es ist nicht erforderlich, dass sich zwei Nutzer gegenseitig folgen, um eine Unterhaltung zu starten.",
        "Blockierte Nutzer können dir keine Nachrichten senden.",
        "Du kannst blockierten Nutzern ebenfalls keine Nachrichten senden.",
      ],
    },
  ],
},

"is-chat-e2ee": {
  title: "Ist der Chat Ende-zu-Ende verschlüsselt (E2EE)?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Elnydo verwendet eine Ende-zu-Ende-Verschlüsselung, um den Inhalt deiner Nachrichten zu schützen. Das System ist so konzipiert, dass Nachrichten nur für die Teilnehmer einer Unterhaltung lesbar sind. Dennoch kann keine Sicherheitsmaßnahme unter allen Umständen absolute Sicherheit garantieren.",
    },
  ],
},

"chat-metadata": {
  title: "Welche Metadaten existieren trotz E2EE?",
  body: [
    {
      type: "bullets",
      items: [
        "Kennungen von Absender und Empfänger.",
        "Zeitstempel der Nachrichtenzustellung.",
        "Technische Informationen zum Zustellstatus.",
        "Informationen zur Gerätesynchronisierung, soweit erforderlich.",
      ],
    },
  ],
},

"can-elnydo-read-chat": {
  title: "Kann Elnydo meine Chatnachrichten lesen?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Elnydo kann den Inhalt Ende-zu-Ende-verschlüsselter Nachrichten nicht lesen. Für den Betrieb des Dienstes können jedoch begrenzte technische Metadaten verarbeitet werden, beispielsweise Informationen über Absender, Empfänger und den Zustellzeitpunkt.",
    },
  ],
},

"send-media-chat": {
  title: "Kann ich Fotos oder Videos im Chat senden?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Der Chat unterstützt derzeit ausschließlich Textnachrichten.",
    },
  ],
},

"delete-chat-message": {
  title: "Kann ich eine Chatnachricht löschen?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Wenn du eine von dir gesendete Nachricht löschst, wird sie für alle Teilnehmer der Unterhaltung entfernt.",
    },
  ],
},

"lost-device-chat": {
  title: "Was passiert, wenn ich mein Gerät verliere?",
  body: [
    {
      type: "bullets",
      items: [
        "Ändere sofort dein Passwort.",
        "Melde dich auf allen Geräten gleichzeitig ab.",
        "Aktiviere die Zwei-Faktor-Authentifizierung (2FA), sofern verfügbar.",
        "Kontaktiere den Support, wenn du einen unbefugten Zugriff vermutest.",
      ],
    },
  ],
},

"message-not-delivered": {
  title: "Warum werden meine Nachrichten nicht zugestellt?",
  body: [
    {
      type: "bullets",
      items: [
        "Der Empfänger ist möglicherweise offline.",
        "Der Empfänger hat dich möglicherweise blockiert.",
        "Deine Internetverbindung ist möglicherweise instabil.",
        "Der Chat-Dienst ist möglicherweise vorübergehend nicht verfügbar.",
      ],
    },
  ],
},

"blocked-chat": {
  title: "Kann ich mit einem Nutzer chatten, den ich blockiert habe?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Durch das Blockieren werden Nachrichten und die meisten direkten Interaktionen zwischen euch verhindert.",
    },
  ],
},

"group-chats": {
  title: "Unterstützt Elnydo Gruppenchats?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Elnydo unterstützt derzeit ausschließlich Unterhaltungen zwischen zwei Personen.",
    },
  ],
},

"screenshots": {
  title: "Verhindert Elnydo Screenshots im Chat?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Nutzer sollten davon ausgehen, dass Inhalte, die auf einem Gerät angezeigt werden, durch Screenshots oder externe Geräte aufgezeichnet werden können.",
    },
  ],
},

///////////////////////////////////////////////
////////Likes, Folgen & Benachrichtigungen////
///////////////////////////////////////////////

"like-unlike": {
  title: "Wie vergebe oder entferne ich ein Like?",
  body: [
    {
      type: "paragraph",
      text: "Öffne einen Beitrag und tippe oder klicke auf die Schaltfläche „Gefällt mir“. Wenn du sie erneut auswählst, wird dein Like wieder entfernt.",
    },
  ],
},

"see-liked-posts": {
  title: "Wo sehe ich Beiträge, die ich gelikt habe?",
  body: [
    {
      type: "paragraph",
      text: "Beiträge, die du mit „Gefällt mir“ markiert hast, findest du in deinem Profil im Bereich „Meine Likes“.",
    },
  ],
},

"follow-unfollow": {
  title: "Wie folge ich jemandem oder entfolge ihm?",
  body: [
    {
      type: "paragraph",
      text: "Öffne das Profil eines Nutzers und wähle „Folgen“. Wenn du der Person nicht mehr folgen möchtest, öffne das Profil erneut und wähle „Entfolgen“.",
    },
  ],
},

"followers-following": {
  title: "Was ist der Unterschied zwischen Followern und Ich folge?",
  body: [
    {
      type: "bullets",
      items: [
        "Follower sind Nutzer, die deinem Profil folgen.",
        "Ich folge zeigt die Nutzer, deren Profilen du folgst.",
        "Beide Listen findest du in deinem Profil.",
      ],
    },
  ],
},

"follow-notification": {
  title: "Werden Nutzer benachrichtigt, wenn ich ihnen folge?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Nutzer erhalten eine Benachrichtigung, wenn jemand ihrem Profil folgt.",
    },
  ],
},

"like-notification": {
  title: "Werden Nutzer benachrichtigt, wenn ich ihren Beitrag like?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Nutzer erhalten eine Benachrichtigung, wenn jemand ihren Beitrag mit „Gefällt mir“ markiert.",
    },
  ],
},

"notification-settings": {
  title: "Kann ich Benachrichtigungen deaktivieren?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Deine Benachrichtigungseinstellungen kannst du in den Kontoeinstellungen anpassen.",
    },
  ],
},

"notifications-not-working": {
  title: "Warum erhalte ich keine Benachrichtigungen?",
  body: [
    {
      type: "bullets",
      items: [
        "Prüfe, ob Benachrichtigungen in Elnydo aktiviert sind.",
        "Überprüfe die Benachrichtigungsberechtigungen deines Geräts.",
        "Deaktiviere gegebenenfalls Energiesparfunktionen, die Benachrichtigungen einschränken.",
        "Melde dich ab und anschließend wieder an.",
      ],
    },
  ],
},

"mute-user": {
  title: "Kann ich jemanden stummschalten, ohne ihn zu blockieren?",
  body: [
    {
      type: "paragraph",
      text: "Falls die Stummschalten-Funktion verfügbar ist, kannst du Benachrichtigungen und die Sichtbarkeit eines Nutzers reduzieren, ohne ihn vollständig zu blockieren.",
    },
  ],
},

"visibility-following": {
  title: "Verändert das Folgen, was ich in der Galerie sehe?",
  body: [
    {
      type: "paragraph",
      text: "Wenn du einem Nutzer folgst, werden dessen Beiträge zusätzlich in „Mein Feed“ angezeigt. Die Galerie und standortbasierte Feeds zeigen weiterhin Inhalte entsprechend deinem Standort und den Funktionen der Plattform an.",
    },
  ],
},

/////////////////////////////////////////
///////////Konto & Sicherheit////////////
/////////////////////////////////////////

"forgot-password": {
  title: "Ich habe mein Passwort vergessen. Was soll ich tun?",
  body: [
    {
      type: "steps",
      items: [
        "Öffne die Anmeldeseite.",
        "Klicke auf „Passwort vergessen“.",
        "Gib deine registrierte E-Mail-Adresse ein.",
        "Folge den Anweisungen in der E-Mail zum Zurücksetzen des Passworts.",
        "Erstelle ein neues, sicheres Passwort.",
      ],
    },
  ],
},

"change-email": {
  title: "Kann ich meine E-Mail-Adresse ändern?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Du kannst deine E-Mail-Adresse in den Kontoeinstellungen ändern. Bevor die Änderung wirksam wird, muss die neue E-Mail-Adresse mit einem sechsstelligen Bestätigungscode verifiziert werden, der an die neue Adresse gesendet wird.",
    },
  ],
},

"change-password": {
  title: "Wie ändere ich mein Passwort?",
  body: [
    {
      type: "steps",
      items: [
        "Öffne die Kontoeinstellungen.",
        "Wähle „Passwort ändern“.",
        "Gib dein aktuelles Passwort ein.",
        "Gib dein neues Passwort ein.",
        "Bestätige die Änderung und speichere sie.",
      ],
    },
  ],
},

"reauth-why": {
  title: "Warum fordert Elnydo eine erneute Anmeldung an?",
  body: [
    {
      type: "paragraph",
      text: "Aus Sicherheitsgründen ist bei sensiblen Aktionen – etwa beim Ändern deiner E-Mail-Adresse oder deines Passworts, beim Löschen deines Kontos oder beim Anpassen von Sicherheitseinstellungen – eine erneute Authentifizierung erforderlich.",
    },
  ],
},

"logout-everywhere": {
  title: "Kann ich mich auf allen Geräten gleichzeitig abmelden?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Unter „Sicherheit“ in den Einstellungen kannst du die Funktion „Von allen Geräten abmelden“ verwenden, um alle aktiven Sitzungen zu beenden.",
    },
  ],
},

"suspicious-login": {
  title: "Ich sehe verdächtige Aktivitäten. Was soll ich tun?",
  body: [
    {
      type: "steps",
      items: [
        "Ändere sofort dein Passwort.",
        "Aktiviere die Zwei-Faktor-Authentifizierung (2FA).",
        "Melde dich auf allen Geräten gleichzeitig ab.",
        "Überprüfe deine letzten Kontoaktivitäten.",
        "Kontaktiere bei Bedarf den Support.",
      ],
    },
  ],
},

"two-factor": {
  title: "Unterstützt Elnydo die Zwei-Faktor-Authentifizierung (2FA)?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Die Zwei-Faktor-Authentifizierung (2FA) kann in den Sicherheitseinstellungen aktiviert werden. Ist sie aktiviert, musst du dich zusätzlich zu deinem Passwort mit einem Bestätigungscode anmelden, der an deine E-Mail-Adresse gesendet wird.",
    },
  ],
},

"account-deletion": {
  title: "Wie lösche ich mein Konto?",
  body: [
    {
      type: "paragraph",
      text: "Die Kontolöschung kann im Bereich „Daten & Datenschutz“ der Einstellungen gestartet werden. Vor der endgültigen Löschung musst du den Vorgang mit einem Bestätigungscode verifizieren, der an deine E-Mail-Adresse gesendet wird.",
    },
  ],
},

"anonymized-what": {
  title: "Was bedeutet „anonymisiert“, wenn ich mein Konto lösche?",
  body: [
    {
      type: "paragraph",
      text: "Anonymisierung bedeutet, dass personenbezogene Informationen entfernt oder von verbleibenden Datensätzen getrennt werden, sodass diese nicht mehr deiner Person zugeordnet werden können.",
    },
  ],
},

"blocked-users-list": {
  title: "Wo finde ich die Liste blockierter Nutzer?",
  body: [
    {
      type: "paragraph",
      text: "Blockierte Nutzer kannst du im Bereich „Profilverwaltung“ der Einstellungen ansehen und verwalten.",
    },
  ],
},

"username-change": {
  title: "Kann ich meinen Profilnamen ändern?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Der Profilname kann nach der Registrierung nicht mehr geändert werden.",
    },
  ],
},

"device-change": {
  title: "Was passiert, wenn ich das Smartphone wechsle?",
  body: [
    {
      type: "paragraph",
      text: "Installiere Elnydo einfach auf deinem neuen Gerät und melde dich mit deinem Konto an.",
    },
  ],
},


///////////////////////////////////////////////////////////
////////////////Sicherheit, Meldungen & Moderation/////////
///////////////////////////////////////////////////////////

"when-block": {
  title: "Wann sollte ich einen Nutzer blockieren?",
  body: [
    {
      type: "paragraph",
      text: "Du solltest einen Nutzer blockieren, wenn er dich belästigt, dir unerwünschte Nachrichten sendet, sich als eine andere Person ausgibt, Spam versendet oder dir bei der Nutzung der Plattform ein unsicheres Gefühl vermittelt.",
    },
    {
      type: "bullets",
      items: [
        "Belästigung oder Mobbing.",
        "Wiederholte unerwünschte Kontaktaufnahme.",
        "Spam oder Betrugsversuche.",
        "Identitätsmissbrauch oder Nachahmung.",
        "Bedrohendes oder beleidigendes Verhalten.",
      ],
    },
  ],
},

"when-report": {
  title: "Wann sollte ich einen Beitrag oder ein Konto melden?",
  body: [
    {
      type: "paragraph",
      text: "Melde Inhalte oder Nutzer, die gegen die Plattformregeln, geltende Gesetze oder unsere Community-Standards verstoßen.",
    },
    {
      type: "bullets",
      items: [
        "Hassrede oder Belästigung.",
        "Gewalt oder Drohungen.",
        "Betrug oder betrügerische Aktivitäten.",
        "Urheberrechtsverletzungen.",
        "Veröffentlichung privater Informationen ohne Zustimmung.",
        "Illegale Inhalte.",
      ],
    },
  ],
},

"what-happens-report": {
  title: "Was passiert nach einer Meldung?",
  body: [
    {
      type: "paragraph",
      text: "Meldungen werden durch unsere Moderationssysteme und – sofern erforderlich – zusätzlich von menschlichen Prüfern überprüft.",
    },
    {
      type: "bullets",
      items: [
        "Die Meldung wird anhand der Plattformrichtlinien geprüft.",
        "Gegebenenfalls werden weitere Informationen berücksichtigt.",
        "Inhalte können eingeschränkt, entfernt oder unverändert belassen werden.",
        "Konten können Verwarnungen oder Einschränkungen erhalten.",
      ],
    },
  ],
},

appeal: {
  title: "Kann ich gegen eine Moderationsentscheidung Einspruch einlegen?",
  body: [
    {
      type: "paragraph",
      text: "Ja. Sofern ein Einspruchsverfahren verfügbar ist, kannst du eine erneute Überprüfung von Moderationsmaßnahmen beantragen, die dein Konto oder deine Inhalte betreffen.",
    },
  ],
},

"false-report": {
  title: "Was passiert, wenn mich jemand zu Unrecht meldet?",
  body: [
    {
      type: "paragraph",
      text: "Meldungen werden anhand der verfügbaren Nachweise und unserer Richtlinien geprüft. Eine Meldung allein führt nicht automatisch zu Sanktionen.",
    },
    {
      type: "note",
      text: "Missbräuchliche oder absichtlich falsche Meldungen können selbst einen Verstoß gegen die Plattformrichtlinien darstellen.",
    },
  ],
},

scams: {
  title: "Wie kann ich Betrug auf Elnydo vermeiden?",
  body: [
    {
      type: "bullets",
      items: [
        "Gib niemals Passwörter oder Bestätigungscodes weiter.",
        "Sei vorsichtig bei Angeboten, die zu gut erscheinen, um wahr zu sein.",
        "Überprüfe die Identität einer Person, bevor du Geld oder persönliche Informationen weitergibst.",
        "Melde verdächtige Nachrichten oder Konten.",
        "Nutze ausschließlich die offiziellen Kommunikationskanäle der Plattform.",
      ],
    },
  ],
},

"danger-emergency": {
  title: "Was soll ich tun, wenn jemand in unmittelbarer Gefahr ist?",
  body: [
    {
      type: "note",
      text: "Elnydo ist kein Notfalldienst.",
    },
    {
      type: "paragraph",
      text: "Wenn sich jemand in unmittelbarer Gefahr befindet oder dringend Hilfe benötigt, wende dich sofort an die örtlichen Notrufdienste oder die zuständigen Behörden.",
    },
  ],
},

copyright: {
  title: "Was gilt für Urheberrechte und das erneute Veröffentlichen von Inhalten?",
  body: [
    {
      type: "paragraph",
      text: "Lade ausschließlich Inhalte hoch oder teile nur Inhalte, deren Rechte du besitzt oder für deren Nutzung du eine entsprechende Erlaubnis hast.",
    },
    {
      type: "bullets",
      items: [
        "Lade keine urheberrechtlich geschützten Inhalte ohne Genehmigung hoch.",
        "Respektiere die Rechte des geistigen Eigentums anderer.",
        "Eine Quellenangabe ersetzt keine erforderliche Genehmigung.",
        "Wiederholte Urheberrechtsverletzungen können zu Einschränkungen deines Kontos führen.",
      ],
    },
  ],
},

"hate-speech": {
  title: "Erlaubt Elnydo Hassrede oder Belästigung?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Hassrede, Belästigung, Diskriminierung, Drohungen und gezielte Angriffe auf Personen sind auf der Plattform nicht erlaubt.",
    },
    {
      type: "note",
      text: "Verstöße können zur Entfernung von Inhalten, Einschränkungen des Kontos oder zu einer dauerhaften Sperrung führen.",
    },
  ],
},

"privacy-violations": {
  title: "Was kann ich tun, wenn jemand meine privaten Informationen veröffentlicht?",
  body: [
    {
      type: "paragraph",
      text: "Melde den betreffenden Inhalt sofort. Das Veröffentlichen personenbezogener Informationen ohne Zustimmung kann gegen unsere Plattformregeln und Datenschutzbestimmungen verstoßen.",
    },
    {
      type: "bullets",
      items: [
        "Melde den Inhalt.",
        "Blockiere das betreffende Konto, falls erforderlich.",
        "Kontaktiere den Support in schwerwiegenden Fällen.",
        "Wende dich an die zuständigen Behörden, wenn deine persönliche Sicherheit gefährdet ist.",
      ],
    },
  ],
},

//////////////////////////////////////////////////////////////
////////////////////////Werbung & Abrechnung//////////////////
//////////////////////////////////////////////////////////////

"ads-required": {
  title: "Benötige ich Werbung, um Elnydo zu nutzen?",
  body: [
    {
      type: "paragraph",
      text: "Nein. Elnydo kann vollständig ohne das Erstellen von Werbeanzeigen genutzt werden. Werbung ist optional und richtet sich an Nutzer, Creator, Organisationen oder Unternehmen, die ihre Inhalte, Produkte, Dienstleistungen oder Veranstaltungen einer größeren Zielgruppe präsentieren möchten.",
    },
  ],
},

"create-ad": {
  title: "Wie erstelle ich eine Werbekampagne?",
  body: [
    {
      type: "steps",
      items: [
        "Öffne den Werbeanzeigen-Manager.",
        "Klicke auf „Kampagne erstellen“.",
        "Gib einen Kampagnennamen ein.",
        "Wähle den gewünschten Standort und die Zielgruppeneinstellungen aus.",
        "Lade dein Bild oder Video hoch.",
        "Füge die Ziel-URL und eine Call-to-Action-Schaltfläche hinzu.",
        "Lege dein Budget und die Laufzeit der Kampagne fest.",
        "Überprüfe die Kampagne und sende sie zur Freigabe ein.",
      ],
    },
  ],
},

"ad-targeting": {
  title: "Wie funktioniert das Anzeigen-Targeting?",
  body: [
    {
      type: "paragraph",
      text: "Werbetreibende können mithilfe der verfügbaren Targeting-Optionen festlegen, welche Zielgruppe ihre Anzeigen sehen soll.",
    },
    {
      type: "bullets",
      items: [
        "Standortbasiertes Targeting.",
        "Sprachbasiertes Targeting.",
        "Altersbeschränkungen, sofern anwendbar.",
        "Interessen- oder Kategorien-Targeting, sofern verfügbar.",
      ],
    },
  ],
},

"ad-review-time": {
  title: "Wie lange dauert die Prüfung einer Anzeige?",
  body: [
    {
      type: "paragraph",
      text: "Werbeanzeigen werden vor der Veröffentlichung geprüft, um sicherzustellen, dass sie unseren Werberichtlinien sowie den gesetzlichen Anforderungen entsprechen.",
    },
    {
      type: "bullets",
      items: [
        "Die meisten Anzeigen werden innerhalb kurzer Zeit geprüft.",
        "Komplexere Kampagnen können eine zusätzliche Überprüfung erfordern.",
        "Prüfungen hinsichtlich Richtlinien oder gesetzlicher Vorgaben können die Bearbeitungszeit verlängern.",
      ],
    },
  ],
},

"ad-rejected": {
  title: "Warum wurde meine Anzeige abgelehnt?",
  body: [
    {
      type: "paragraph",
      text: "Werbeanzeigen können abgelehnt werden, wenn sie gegen unsere Werberichtlinien oder gesetzliche Vorgaben verstoßen.",
    },
    {
      type: "bullets",
      items: [
        "Irreführende Aussagen oder Inhalte.",
        "Verbotene Produkte oder Dienstleistungen.",
        "Defekte oder unsichere Ziel-URLs.",
        "Medien mit unzureichender Qualität oder ungeeigneten Inhalten.",
        "Verstöße gegen Richtlinien oder eingeschränkte Inhalte.",
      ],
    },
    {
      type: "note",
      text: "Prüfe den Ablehnungsgrund, nimm die erforderlichen Änderungen vor und reiche die Anzeige anschließend erneut ein.",
    },
  ],
},

"billing-when-charged": {
  title: "Wann werden Werbekosten berechnet?",
  body: [
    {
      type: "paragraph",
      text: "Die Berechnung der Werbekosten richtet sich nach dem gewählten Abrechnungsmodell und den Einstellungen deiner Kampagne.",
    },
    {
      type: "bullets",
      items: [
        "Kosten können beim Start einer Kampagne anfallen.",
        "Kosten können erst entstehen, nachdem Werbeaktivitäten generiert wurden.",
        "Der Abrechnungszeitpunkt hängt von deiner gewählten Zahlungsmethode und Konfiguration ab.",
      ],
    },
  ],
},

"ad-spend-not-delivering": {
  title: "Warum wird mein Werbebudget nicht ausgegeben oder meine Anzeige nicht ausgeliefert?",
  body: [
    {
      type: "paragraph",
      text: "Es gibt verschiedene Gründe, warum eine Kampagne möglicherweise nicht ausgeliefert wird.",
    },
    {
      type: "bullets",
      items: [
        "Die Kampagne befindet sich noch in der Prüfung.",
        "Die Anzeige wurde abgelehnt.",
        "Die Zielgruppeneinstellungen sind zu stark eingeschränkt.",
        "Das Kampagnenbudget ist zu niedrig.",
        "Die Kampagne wurde pausiert.",
        "Am ausgewählten Standort ist die potenzielle Reichweite der Zielgruppe zu gering.",
      ],
    },
  ],
},

"ad-creative-best": {
  title: "Was macht eine gute Werbeanzeige aus?",
  body: [
    {
      type: "paragraph",
      text: "Erfolgreiche Werbeanzeigen sind klar, relevant und visuell ansprechend.",
    },
    {
      type: "bullets",
      items: [
        "Verwende hochwertige Bilder oder Videos.",
        "Halte deine Botschaft einfach und leicht verständlich.",
        "Füge eine klare Handlungsaufforderung (Call-to-Action) hinzu.",
        "Stelle sicher, dass der Inhalt der Anzeige zur Zielseite passt.",
        "Vermeide übermäßig viel Text oder irreführende Aussagen.",
      ],
    },
  ],
},

refunds: {
  title: "Bietet ihr Rückerstattungen für Werbung an?",
  body: [
    {
      type: "paragraph",
      text: "Ob eine Rückerstattung möglich ist, hängt von unseren Werberichtlinien, dem Abrechnungsstatus und den Umständen des jeweiligen Falls ab.",
    },
    {
      type: "bullets",
      items: [
        "Prüfe die geltenden Werbebedingungen.",
        "Kontaktiere den Support, wenn du von einem Abrechnungsfehler ausgehst.",
        "Rückerstattungsanträge werden – sofern anwendbar – individuell geprüft.",
      ],
    },
  ],
},

invoices: {
  title: "Wo finde ich meine Rechnungen?",
  body: [
    {
      type: "paragraph",
      text: "Rechnungen und Abrechnungsunterlagen findest du im Werbeanzeigen-Manager oder im Abrechnungsbereich deines Kontos.",
    },
    {
      type: "steps",
      items: [
        "Öffne den Werbeanzeigen-Manager.",
        "Wechsle zum Bereich „Abrechnung“ oder „Zahlungen“.",
        "Wähle „Rechnungen“ aus.",
        "Zeige deine verfügbaren Rechnungen an oder lade sie herunter.",
      ],
    },
  ],
},

////////////////////////////////////////////////////////
////////////////////Problembehebung/////////////////////
////////////////////////////////////////////////////////

"app-crashes": {
  title: "Die App stürzt ab oder friert ein. Was kann ich tun?",
  body: [
    {
      type: "paragraph",
      text: "Gelegentliche Abstürze können durch vorübergehende Softwareprobleme, veraltete Versionen, unzureichende Geräteleistung oder Netzwerkprobleme verursacht werden.",
    },
    {
      type: "steps",
      items: [
        "Schließe die App und öffne sie erneut.",
        "Prüfe, ob ein Update verfügbar ist.",
        "Starte dein Gerät neu.",
        "Stelle sicher, dass ausreichend freier Speicherplatz vorhanden ist.",
        "Versuche es erneut mit einer stabilen Internetverbindung.",
      ],
    },
  ],
},

"cant-login": {
  title: "Ich kann mich nicht anmelden. Woran kann das liegen?",
  body: [
    {
      type: "bullets",
      items: [
        "Die E-Mail-Adresse oder das Passwort ist falsch.",
        "Dein Konto wurde noch nicht bestätigt.",
        "Es liegt ein vorübergehendes Server- oder Netzwerkproblem vor.",
        "Probleme mit dem Browser- oder App-Cache.",
        "Sicherheitsbeschränkungen aufgrund verdächtiger Aktivitäten.",
      ],
    },
    {
      type: "note",
      text: "Nutze bei Bedarf die Funktion „Passwort vergessen“, um dein Passwort zurückzusetzen.",
    },
  ],
},

"slow-feed": {
  title: "Die Galerie ist langsam. Wie kann ich sie beschleunigen?",
  body: [
    {
      type: "bullets",
      items: [
        "Überprüfe die Geschwindigkeit deiner Internetverbindung.",
        "Wechsle zwischen WLAN und mobilen Daten.",
        "Schließe nicht benötigte Apps im Hintergrund.",
        "Aktualisiere den Galerie-Feed.",
        "Aktualisiere die App auf die neueste Version.",
      ],
    },
  ],
},

"no-sound": {
  title: "Mein Video hat keinen Ton. Warum?",
  body: [
    {
      type: "bullets",
      items: [
        "Die Lautstärke deines Geräts ist möglicherweise stummgeschaltet.",
        "Das hochgeladene Video enthält möglicherweise keine Tonspur.",
        "Browser- oder Geräteberechtigungen können die Audiowiedergabe einschränken.",
        "Ein verbundenes Bluetooth-Gerät gibt den Ton möglicherweise wieder.",
        "Die Mediendatei könnte beschädigt sein.",
      ],
    },
  ],
},

"camera-permission": {
  title: "Die Berechtigung für Kamera oder Fotos fehlt. Wie behebe ich das?",
  body: [
    {
      type: "steps",
      items: [
        "Öffne die Einstellungen deines Geräts.",
        "Suche Elnydo in der App-Liste.",
        "Öffne den Bereich „Berechtigungen“.",
        "Aktiviere den Zugriff auf Kamera sowie Fotos/Medien.",
        "Starte die App bei Bedarf neu.",
      ],
    },
  ],
},

"location-permission": {
  title: "Die Standortberechtigung fehlt. Wie behebe ich das?",
  body: [
    {
      type: "steps",
      items: [
        "Öffne die Einstellungen deines Geräts.",
        "Suche Elnydo in der App-Liste.",
        "Öffne den Bereich „Berechtigungen“.",
        "Aktiviere den Standortzugriff.",
        "Kehre zur App zurück und aktualisiere den Standort.",
      ],
    },
  ],
},

"notifications-disabled": {
  title: "Benachrichtigungen sind in der App aktiviert, ich erhalte aber trotzdem keine.",
  body: [
    {
      type: "bullets",
      items: [
        "Überprüfe die Benachrichtigungseinstellungen deines Geräts.",
        "Deaktiviere die Akkuoptimierung für Elnydo.",
        "Stelle sicher, dass Benachrichtigungen sowohl in der App als auch im Betriebssystem aktiviert sind.",
        "Prüfe, ob Fokusmodus, „Nicht stören“ oder der Lautlosmodus aktiviert sind.",
        "Melde dich ab und anschließend wieder an.",
      ],
    },
  ],
},

"blocked-content": {
  title: "Warum sehe ich weniger Beiträge als mein Freund in derselben Stadt?",
  body: [
    {
      type: "paragraph",
      text: "Die in der Galerie angezeigten Inhalte können je nach Kontoeinstellungen, Moderationsmaßnahmen, blockierten Nutzern, ausgeblendeten Inhalten, Standorteinstellungen und dem Zeitpunkt der Feed-Aktualisierung variieren.",
    },
  ],
},

"profile-not-updating": {
  title: "Änderungen an meinem Profil werden nicht angezeigt.",
  body: [
    {
      type: "bullets",
      items: [
        "Aktualisiere die Seite oder starte die App neu.",
        "Warte einige Minuten, bis die Synchronisierung abgeschlossen ist.",
        "Überprüfe, ob die Änderungen erfolgreich gespeichert wurden.",
        "Kontrolliere deine Internetverbindung.",
        "Melde dich ab und wieder an, falls das Problem weiterhin besteht.",
      ],
    },
  ],
},

"contact-support-when": {
  title: "Wann sollte ich den Support kontaktieren?",
  body: [
    {
      type: "paragraph",
      text: "Kontaktiere den Support, wenn du ein Problem mithilfe der FAQ, Anleitungen oder der Schritte zur Problembehebung nicht selbst lösen kannst.",
    },
    {
      type: "bullets",
      items: [
        "Du kannst nicht auf dein Konto zugreifen.",
        "Zahlungen oder Abrechnungen scheinen fehlerhaft zu sein.",
        "Ein technisches Problem besteht trotz aller Lösungsversuche weiterhin.",
        "Du vermutest einen unbefugten Zugriff auf dein Konto.",
        "Du benötigst Unterstützung bei Moderations-, Datenschutz- oder rechtlichen Anliegen.",
      ],
    },
    {
      type: "note",
      text: "Wenn du den Support kontaktierst, gib möglichst viele Informationen an, einschließlich Screenshots, Fehlermeldungen und der Schritte, die zum Problem geführt haben.",
    },
  ],
},
      },

  }, // schließt faq

} as const;



export default faq;